import { RouteDataFuncArgs, useParams, useRouteData } from "@solidjs/router";
import { createEffect, Show, VoidComponent } from "solid-js";
import { z } from "zod";
import DraftInvoiceForm from "~/components/DraftInvoiceForm";
import PageSection from "~/components/PageSection";
import { createMutation } from "~/components/RPCProvider";
import { routeData as dashboardRouteData } from "~/routes/dashboard";
import { supportedInvoiceTypes } from "~/schemas/invoices";
const routeParams = z.object({
  issuerId: z.string().uuid(),
  draftInvoiceId: z.string().uuid(),
  invoiceType: z.enum(supportedInvoiceTypes),
});
export const routeData = ({ data, params }: RouteDataFuncArgs) => {
  const input = routeParams.parse(params);
  const [accountInfo] = data as ReturnType<typeof dashboardRouteData>;
  return {
    draftInvoice: createMutation("findOrCreateDraftInvoice", input),
    accountInfo,
  };
};

const DraftInvoiceEditor: VoidComponent = () => {
  const { draftInvoice, accountInfo } = useRouteData<typeof routeData>();
  const params = useParams();
  const { invoiceType, draftInvoiceId, issuerId } = routeParams.parse(params);
  createEffect(() => console.debug("draftInvoice", draftInvoice()));

  return (
    <PageSection>
      <Show when={accountInfo() && draftInvoice()} fallback="Loading...">
        <DraftInvoiceForm
          invoiceType={invoiceType}
          issuer={assert(
            accountInfo()?.issuers.find((issuer) => issuer.id === issuerId)
          )}
          draftInvoiceId={draftInvoiceId}
          draft={assert(draftInvoice()).draft}
        />
      </Show>
    </PageSection>
  );
};

export default DraftInvoiceEditor;
function assert<T>(expression: T): NonNullable<T> {
  if (expression === undefined) {
    throw new Error("unexpected undefined value ");
  }
  if (expression === null) {
    throw new Error("unexpected null value ");
  }
  return expression;
}
